var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7139 3.76961C15.7249 3.92061 15.7249 4.07161 15.7249 4.22361C15.7249 8.82861 12.2189 14.1356 5.81194 14.1356C3.83794 14.1356 2.00394 13.5636 0.460938 12.5716C0.741937 12.6036 1.01194 12.6136 1.30294 12.6136C2.93194 12.6136 4.42994 12.0636 5.62794 11.1256C4.09594 11.0936 2.81294 10.0896 2.37094 8.70861C2.58594 8.74061 2.80194 8.76261 3.02694 8.76261C3.34094 8.76261 3.65394 8.71961 3.94494 8.64461C2.34894 8.32061 1.15094 6.91861 1.15094 5.22561C1.15094 5.21461 1.15094 5.19261 1.15094 5.18261C1.61494 5.44061 2.15394 5.60261 2.72594 5.62461C1.78794 4.99861 1.17294 3.93061 1.17294 2.72361C1.17294 2.07661 1.34594 1.48261 1.64794 0.964613C3.36294 3.07961 5.94094 4.46061 8.83194 4.61061C8.77694 4.35161 8.74494 4.08161 8.74494 3.81161C8.74494 1.89261 10.2989 0.328613 12.2289 0.328613C13.2319 0.328613 14.1379 0.748613 14.7749 1.42861C15.5619 1.27761 16.3159 0.986613 16.9859 0.587613C16.7269 1.39661 16.1769 2.07661 15.4539 2.50661C16.1559 2.43161 16.8349 2.23761 17.4609 1.96761C16.9859 2.65761 16.3929 3.27361 15.7139 3.76961Z",
    fill: "#0A142F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.49f6d3bea131ac60431c103384b44fbf.svg";
export { ForwardRef as ReactComponent };